'use strict';

const cfg = window.duTheme || {};
const storageKey = cfg.cookieKey || 'dom_uyuta_cookie_consent';
const storageValue = cfg.cookieValue || 'v1';

function qs( sel, root ) {
	return ( root || document ).querySelector( sel );
}

function initCookieBanner() {
	const banner = qs( '#du-cookie-banner' );
	const accept = qs( '#du-cookie-accept' );
	if ( ! banner || ! accept ) {
		return;
	}

	try {
		if ( localStorage.getItem( storageKey ) === storageValue ) {
			banner.hidden = true;
			return;
		}
	} catch ( e ) {
		/* ignore */
	}

	banner.hidden = false;

	accept.addEventListener( 'click', () => {
		try {
			localStorage.setItem( storageKey, storageValue );
		} catch ( err ) {
			/* ignore */
		}
		banner.hidden = true;
		document.dispatchEvent(
			new CustomEvent( 'du:cookie-consent', { detail: { accepted: true } } )
		);
	} );
}

function initMobileNav() {
	const toggle = qs( '#du-nav-toggle' );
	const wrap = qs( '#du-primary-nav-wrap' );
	if ( ! toggle || ! wrap ) {
		return;
	}

	toggle.addEventListener( 'click', () => {
		const open = wrap.classList.toggle( 'is-open' );
		toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
	} );
}

function initCtaTracking() {
	document.addEventListener( 'click', ( ev ) => {
		const el = ev.target.closest( '[data-goal]' );
		if ( ! el ) {
			return;
		}
		document.dispatchEvent(
			new CustomEvent( 'du:track', {
				detail: {
					goal: el.getAttribute( 'data-goal' ),
					ctaId: el.getAttribute( 'data-cta-id' ) || '',
				},
			} )
		);
	} );
}

let motionLoaded = false;
let motionCleanup = null;

function scheduleMotionBoot() {
	const page =
		cfg.motionPage ||
		document.body.getAttribute( 'data-motion-page' ) ||
		'';
	const enabled =
		cfg.motionEnabled !== false &&
		page &&
		page !== 'legal';

	if ( ! enabled || motionLoaded ) {
		return;
	}

	const load = () => {
		if ( motionLoaded ) {
			return;
		}
		motionLoaded = true;
		bootMotion( page );
	};

	if ( 'requestIdleCallback' in window ) {
		window.requestIdleCallback( load, { timeout: 2500 } );
	} else {
		setTimeout( load, 1200 );
	}

	const once = () => {
		load();
		window.removeEventListener( 'scroll', once );
		window.removeEventListener( 'pointerdown', once );
	};
	window.addEventListener( 'scroll', once, { passive: true, once: true } );
	window.addEventListener( 'pointerdown', once, { once: true } );
}

async function bootMotion( page ) {
	try {
		const reduced = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;
		if ( reduced ) {
			document.documentElement.classList.add( 'motion-reduce' );
			return;
		}

		if ( page === 'home' ) {
			await import( './motion-home.js' );
		} else {
			const mod = await import( './motion-lite.js' );
			if ( mod.startLiteMotion ) {
				mod.startLiteMotion( page );
			}
		}
	} catch ( err ) {
		console.warn( '[dom-uyuta] motion load failed', err );
	}
}

window.addEventListener( 'pagehide', () => {
	if ( typeof motionCleanup === 'function' ) {
		motionCleanup();
	}
} );

document.addEventListener( 'DOMContentLoaded', () => {
	initCookieBanner();
	initMobileNav();
	initCtaTracking();
	scheduleMotionBoot();
} );
